import { API,APIFORMDATA } from '../middlewares/APIUtils.tsx';
// ================= TEMPLATES =================
export const createTemplateAPIHelper = async (payload: any) => {
  try {
    const response = await APIFORMDATA.post(
      `/api/templates`, // 1. URL
      payload
    );
    return response.data; 
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getTemplatesAPIHelper = async (cid: any) => {
  try {
    const response = await API.get(
      `/api/${cid}/templates`
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getTemplateByIdAPIHelper = async (id:any) => {
  try {
    const response = await API.get(
      `/api/templates/${id}`
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateTemplateAPIHelper = async (payload: any) => {
  try {
    const response = await APIFORMDATA.put(
      `/api/templates/${payload.id}`,
      payload.data,
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteTemplateAPIHelper = async (id:string|number) => {
  try {
    const response = await API.delete(
      `/api/templates/${id}`
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// ================= LETTERS =================

export const createLetterAPIHelper = async (payload: any) => {
  try {
    const response = await APIFORMDATA.post(
      `/api/letters`,
      payload
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};


export const getLettersAPIHelper = async (payload: any) => {
  try {
    const response = await API.get(`/api/${payload}/letters`);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getLetterByIdAPIHelper = async (id) => {
  try {
    const response = await API.get(
      `/api/letters/${id}`
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateLetterAPIHelper = async (payload: any) => {
  try {
    const response = await APIFORMDATA.put(
      `/api/letters/${payload.id}`,
      payload.data,
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};



export const deleteLetterAPIHelper = async (id) => {
  try {
    const response = await API.delete(
      `/api/letters/${id}`
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};


export const sendLetterEmailAPIHelper = async (id: string | number, payload: any) => {
  try {
    const response = await API.post(
      `/api/letters/${id}/send-email`,
      payload
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }

};

//  Fetch the immutable audit logs (sent letters only)
export const getIssuedLogsAPIHelper = async (cid: any) => {
  try {
    // Note: Assuming your base route for letters includes the company ID
    const response = await API.get(
      `/api/${cid}/letters/audit/issued`
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};


// ================= EXTERNAL SIGNING (PUBLIC) =================

// 1. Fetch the document securely without authentication
export const getPublicLetterAPIHelper = async (id: string) => {
  try {
    const response = await API.get(`/api/letters/${id}/public`);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// 2. Submit the signature image securely
export const submitExternalSignatureAPIHelper = async (id: string,token: string, formData: FormData) => {
  try {
    // Make sure to use APIFORMDATA since we are sending an image file!
   const response = await APIFORMDATA.post(`/api/letters/${id}/submit-external-signature?token=${token}`, formData);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

//  Trigger the signing link email for external signatories
export const sendSigningLinkAPIHelper = async (id: string | number, payload: any) => {
  try {
    const response = await API.post(
      `/api/letters/${id}/send-signing-link`,
      payload
    );
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};


// ================= ESIGN (DIGILOCKER) =================

export const initiateESignAPIHelper = async () => {
  try {
    const response = await API.get(`/api/esign/initiate`);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// Replace your verifyESignAPIHelper with this:
export const verifyESignAPIHelper = async (payload: { code: string, code_verifier: string }) => {
  try {
    const response = await API.post(`/api/esign/verify-digilocker`, payload);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};


// ================= ESIGN (DIGILOCKER) =================
